// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile_3Zc8o","button":"Profile_button_3yYum","image":"Profile_image_3fLa3"};